module.exports = __webpack_public_path__ + "img/question8.7a7ad451.png";